import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  MotifBreadcrumb,
  MotifBreadcrumbItem,
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirArrowLeft } from "@ey-xd/motif-icon";

type BreadcrumbItem = {
  text: string;
  url?: string;
  icon?: JSX.Element;
  variant?: "default" | "alt";
  disabled?: boolean;
  blockNavigation?: boolean;
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  ariaLabel?: string;
};

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, ariaLabel }) => {
  let nav = useNavigate();
  function handleBackFuction() {
    let item: any = undefined;
    if (items.length > 1) {
      item = items[items.length - 2];
    } else {
      item = items[0];
    }
    if (!item?.blockNavigation && item?.url) {
      nav(item?.url);
    }
  }
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {items?.length >= 3 && (
        <div
          onClick={() => handleBackFuction()}
          style={{ position: "relative", top: "-2px", cursor: "pointer" }}
        >
          <MotifIcon size="24px" src={IconoirArrowLeft} />
        </div>
      )}
      <div>
        <MotifBreadcrumb aria-label={ariaLabel}>
          {items.map((item, index) => (
            <MotifBreadcrumbItem
              key={index}
              variant={item.variant || "default"}
              disabled={item.disabled}
            >
              {item.url ? (
                <Link
                  onClick={(e) => {
                    if (item?.blockNavigation) {
                      e.preventDefault();
                    }
                  }}
                  to={item?.url ? item.url : ""}
                  className="display-flex align-items-center breadcrumb-link"
                >
                  {item.icon && index === 0 && items?.length < 3 && (
                    <span>{item.icon}</span>
                  )}
                  <span
                    className={`${
                      item.icon && index === 0 ? "pad-l-10" : "margin-left-0"
                    } word-break-all`}
                  >
                    {item.text} 
                  </span>
                </Link>
              ) : (
                <div className="display-flex align-items-center">
                  {item.icon && <span>{item.icon}</span>}
                  <span
                  style={{ overflowWrap: "anywhere" }}
                    className={`pad-l-10 ${item.icon ? "" : "margin-left-0"} word-break-all`}
                  >
                    {item.text}
                  </span>
                </div>
              )}
            </MotifBreadcrumbItem>
          ))}
        </MotifBreadcrumb>
      </div>
    </div>
  );
};

export default Breadcrumb;
